import { image, video, woo, wordpress } from '../../../utils/icons';


export const sourceItem = [
    {
        sourceType: "image",
        icon: image,
        title: "Image Slider"
    },

    {
        sourceType: "posts",
        icon: wordpress,
        title: "Posts Slider"
    },
    {
        sourceType: "woo",
        icon: woo,
        title: "WooCommerce Slider"
    },
    {
        sourceType: "video",
        icon: video,
        title: "Video Slider"
    },
]
